module.exports = __webpack_public_path__ + "static/media/en.d3ddd602.svg";